/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ZendeskData = {
  articles: boolean;
};

/** @internal */
export const ZendeskData$inboundSchema: z.ZodType<
  ZendeskData,
  z.ZodTypeDef,
  unknown
> = z.object({
  articles: z.boolean(),
});
/** @internal */
export type ZendeskData$Outbound = {
  articles: boolean;
};

/** @internal */
export const ZendeskData$outboundSchema: z.ZodType<
  ZendeskData$Outbound,
  z.ZodTypeDef,
  ZendeskData
> = z.object({
  articles: z.boolean(),
});

export function zendeskDataToJSON(zendeskData: ZendeskData): string {
  return JSON.stringify(ZendeskData$outboundSchema.parse(zendeskData));
}
export function zendeskDataFromJSON(
  jsonString: string,
): SafeParseResult<ZendeskData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ZendeskData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ZendeskData' from JSON`,
  );
}
